const TERMS_OF_USE_AND_SALE = 'https://legal.fabfitfun.com/#terms-of-use';
const SUBSCRIPTION_TERMS = 'https://legal.fabfitfun.com/#box-membership-terms';
const PRIVACY_POLICY = 'https://legal.fabfitfun.com/#privacy-policy';
const FABFITFUN_SUPPORT =
  'https://support.fabfitfun.com/?a=How-can-I-contact-Customer-Care---id--2tnlqvo8SqWH7h_ujSe5NQ';
const MORE_DETAILS =
  'https://support.fabfitfun.com/hc/en-us/articles/360035968991-What-s-your-cancellation-policy-';
const LEARN_MORE =
  'https://support.fabfitfun.com/hc/en-us/articles/360035609492';

export {
  TERMS_OF_USE_AND_SALE,
  SUBSCRIPTION_TERMS,
  PRIVACY_POLICY,
  FABFITFUN_SUPPORT,
  MORE_DETAILS,
  LEARN_MORE,
};
